import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SettingsPageComponent from './settings/SettingsPageComponent'
import MainHeader from "../../lib/struct/headers/MainHeader"
import Page from "../../lib/struct/page/Page"
import FixedFooter from "../../lib/struct/page/FixedFooter"
import SaveButton from "../../lib/struct/page/SaveButton"
import SettingsContext from "../context/SettingsContext"


@observer export default class SettingsComponent extends Component {
    render() {
        /** @type {SettingsContext} */
        const context = this.props.context


        if (context.stocks === undefined) {
            context.stocks = [
                {
                    critical_count: "2",
                    id: "1",
                    is_public: true,
                    is_virtual: false,
                    low_count: "5",
                    name: "test",
                    sort: "1",
                },
                {
                    critical_count: "2",
                    id: "2",
                    is_public: true,
                    is_virtual: false,
                    low_count: "5",
                    name: "test1",
                    sort: "2",
                }
            ]
        }
        context.shipping_methods = [
            {
                label: 'OLOLO',
                value: '1'
            },
            {
                label: 'KEKEKE',
                value: '2'
            },
            {
                label: 'BUGOGA',
                value: '3'
            },
        ]
        context.payment_methods = [
            {
                label: 'Предоплата',
                value: 'prepaid'
            },
            {
                label: 'Наличными при получении',
                value: 'cash'
            },
            {
                label: 'Банковской картой при получении',
                value: 'card'
            },
            {
                label: 'Заказ оплачивает организация',
                value: 'b2b'
            },
        ]


        return (
            <div>
                <SettingsPageComponent context={context}/>

            </div>
        )
    }
}